/* No tracking or remote dependencies. Works on initial load and theme-editor reload. */
if (!customElements.get('pw-carousel')) {
  customElements.define('pw-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track || this.bound) return;
      this.bound = true;
      this.hovered = false;
      this.pressed = false;
      this.inView = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.track.children];
      this.slides.forEach((slide, index) => {
        const label = slide.querySelector('.jl-scene-index');
        if (label) label.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(this.slides.length).padStart(2, '0');
      });
      const dots = this.querySelector('[data-dots]');
      this.buttons = this.slides.map((_, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', document.documentElement.lang.startsWith('zh') ? `查看第 ${index + 1} 张图片` : `Go to image ${index + 1}`);
        button.addEventListener('click', () => this.go(index), options);
        dots?.append(button);
        return button;
      });
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index() - 1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index() + 1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index() + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.track.tabIndex = 0;
      this.track.setAttribute('role', 'region');
      this.track.setAttribute('aria-label', this.dataset.label || 'Shop the scene');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
      this.resumeDelay = Math.max(2000, Number(this.dataset.resumeDelay) || 3000);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; clearTimeout(this.timer); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(this.resumeDelay); }, options);
      this.addEventListener('pointerdown', () => { this.pressed = true; clearTimeout(this.timer); }, options);
      window.addEventListener('pointerup', () => { this.pressed = false; this.schedule(this.resumeDelay); }, options);
      window.addEventListener('pointercancel', () => { this.pressed = false; this.schedule(this.resumeDelay); }, options);
      this.addEventListener('focusin', () => clearTimeout(this.timer), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule(this.resumeDelay)), options);
      this.track.addEventListener('scroll', () => this.schedule(this.resumeDelay), { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.schedule(this.resumeDelay), options);
      this.reducedMotion.addEventListener('change', () => this.schedule(this.resumeDelay), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule(this.resumeDelay);
      }, { threshold: 0.1 });
      this.observer.observe(this);
      this.update();
    }
    schedule(delay = this.interval) {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || !this.inView || document.hidden || this.hovered || this.pressed || this.contains(document.activeElement) || this.reducedMotion.matches) return;
      this.timer = setTimeout(() => { this.go(this.index() + 1); this.schedule(); }, delay);
    }
    index() {
      const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      return this.slides.reduce((best, slide, index) => {
        const rect = slide.getBoundingClientRect();
        const previous = this.slides[best].getBoundingClientRect();
        return Math.abs(rect.left + rect.width / 2 - center) < Math.abs(previous.left + previous.width / 2 - center) ? index : best;
      }, 0);
    }
    go(index) {
      if (!this.slides.length) return;
      const target = this.slides[(index + this.slides.length) % this.slides.length];
      const rect = target.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      this.track.scrollBy({ left: rect.left + rect.width / 2 - trackRect.left - this.track.clientWidth / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const index = this.index();
      this.buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); this.querySelector('[data-dots]')?.replaceChildren(); this.bound = false; }
  });
}
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.pw-header details[open]').forEach(item => { item.open = false; item.querySelector('summary')?.focus(); });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.pw-header details[open]').forEach(item => { if (!item.contains(event.target)) item.open = false; });
  if (event.target.closest('.pw-mobile-menu a')) document.querySelectorAll('.pw-mobile-menu[open]').forEach(item => { item.open = false; });
});
